module.exports = __webpack_public_path__ + "static/media/error_payment.fea3a7d2.png";